var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex w-full gap-x-2"},[_c('consumer-search-reference-no',{staticClass:"w-1/5"}),_c('consumer-search-suggests',{staticClass:"w-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }